import React from 'react';
import { isBirthdayPromoActive } from '../constants';

/**
 * BirthdayPromoBanner — site-wide Aureus Birthday 2026 banner.
 *
 * ANNIVERSARY (BIRTHDAY 2026) SUNSET: the Anniversary promotion is retired from
 * public view. This banner is force-disabled — the date gate below is combined
 * with a hard `ANNIVERSARY_ENABLED = false` kill switch so nothing renders even
 * inside the historical promo window. Reversible: flip ANNIVERSARY_ENABLED back
 * to true to restore the original date-gated behaviour. The BOGO / Single-Share
 * Special promotion is a separate surface and is unaffected.
 *
 * (Original: rendered INSIDE NewsTickerBar; premium gold theme; auto-hid after
 * the promo window via isBirthdayPromoActive().)
 */
const ANNIVERSARY_ENABLED = false;

export const BirthdayPromoBanner: React.FC = () => {
  if (!ANNIVERSARY_ENABLED || !isBirthdayPromoActive()) return null;

  return (
    <div className="birthday-promo-banner" role="banner" aria-label="Aureus Anniversary celebration">
      <span className="birthday-promo-text">
        🎉 Celebrating the Aureus Anniversary — 25 Jul → 6 Aug 🎂 Special Anniversary Share Packages available now!
      </span>
      <style>{`
        .birthday-promo-banner {
          position: fixed;
          top: 40px;
          left: 0;
          right: 0;
          z-index: 45;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #121212;
          border-bottom: 2px solid #f59e0b;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), 0 0 18px rgba(255, 215, 0, 0.15);
          overflow: hidden;
        }
        .birthday-promo-text {
          color: #FFD700;
          font-family: 'Inter', 'Segoe UI', 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 14px;
          font-weight: 700;
          white-space: nowrap;
          text-align: center;
          padding: 0 16px;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
        }
        @media (max-width: 768px) {
          .birthday-promo-banner {
            top: 35px;
            height: 30px;
          }
          .birthday-promo-text {
            font-size: 11px;
            padding: 0 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default BirthdayPromoBanner;
